export default __webpack_public_path__ + "static/patio-areas-comuns-ebf26ea432488490ff9c5926c21a365e.webp";